import template from './price-rate.jade';
import currency from '../../../enums/currency';

const vatVisibleForObjects = ['office', 'shoppingArea', 'freeAppointmentObject', 'industry', 'warehouse', 'business'];

export default angular.module('cian.addForm.priceRate', []).directive('cianAfPriceAndDealTermsPriceRate', [
  '$sce',
  '$filter',
  'categoryService',
  ($sce, $filter, categoryService) => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    link(scope, element, attrs, ctrl) {
      const getRate = (price, period) => (ctrl.isRent && period === 'annual' ? price / 12 : price);
      const formatPrice = value => $filter('currency')(value, '', 0);
      const computePrice = (area, rate) => (area ? formatPrice(area * rate) : undefined);

      scope.$watch(
        () => ({
          category: ctrl.ad.category,
          areaFrom: ctrl.ad.minArea,
          areaToDefault: ctrl.ad.totalArea,
          areaToBuilding: (ctrl.ad.building && ctrl.ad.building.totalArea) || ctrl.ad.totalArea,
          areaToLand: ctrl.ad.land && ctrl.ad.land.area,
          priceRate: ctrl.ad.bargainTerms.price,
          paymentPeriod: ctrl.ad.bargainTerms.paymentPeriod,
        }),
        newValue => {
          if (!newValue) {
            return;
          }
          const { areaFrom, priceRate, paymentPeriod } = newValue;
          const areaTo = ctrl.getTotalArea();
          if ((areaFrom > 0 || areaTo > 0) && priceRate > 0) {
            const currentRate = getRate(priceRate, paymentPeriod);
            ctrl.computedPrice.from = computePrice(areaFrom, currentRate);
            ctrl.computedPrice.to = areaFrom !== areaTo ? computePrice(areaTo, currentRate) : undefined;
          } else {
            ctrl.computedPrice = {};
          }
        },
        true,
      );

      // TODO перенести валюту в отдельную директиву?
      scope.$watch(
        () => ctrl.ad.bargainTerms.currency,
        newValue => {
          const currencyValue = currency.find(item => {
            return item.key === newValue;
          }).name;

          ctrl.currency = $sce.trustAsHtml(currencyValue);
        },
      );
    },
    controller: [
      '$scope',
      'deviceService',
      function ($scope, deviceService) {
        this.isMobile = deviceService.isMobile;
        // TODO вынести в enum поставить правильные значения
        this.computedPrice = {};
        this.periodOptions = [
          { text: 'в месяц', value: 'monthly' },
          { text: 'в год', value: 'annual' },
        ];

        this.ad.bargainTerms = this.ad.bargainTerms || {};
        this.ad.bargainTerms.paymentPeriod = this.ad.bargainTerms.paymentPeriod || this.periodOptions[0].value;

        const { dealType } = categoryService.getInfoByCategory(this.ad.category);
        this.isRent = dealType === 'rent';

        const setPriceType = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);
          if (objectType === 'commercialLand' && angular.isObject(this.ad.land) && this.ad.land.areaUnitType) {
            // если это коммерческая земля priceType напрямую зависит от areaUnitType
            this.ad.bargainTerms.priceType = this.ad.land.areaUnitType;
          } else if (objectType !== 'commercialLand') {
            this.ad.bargainTerms.priceType = 'squareMeter';
          }
        };

        const priceTypeText = {
          squareMeter: 'м<sup>2</sup>',
          sotka: 'сотку',
          hectare: 'гектар',
        };
        this.getPriceTypeText = () => priceTypeText[this.ad.bargainTerms.priceType] || priceTypeText.squareMeter;

        this.getTotalArea = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);
          switch (objectType) {
            case 'building':
              return this.ad.totalArea || this.ad.building.totalArea;
            case 'commercialLand':
              return this.ad.land.area;
            default:
              return this.ad.totalArea;
          }
        };

        if (this.ad.id && !Object.keys(priceTypeText).includes(this.ad.bargainTerms.priceType)) {
          // Если редактирование и тип цены не за квадратный метр
          const totalArea = Number(this.getTotalArea());
          if (angular.isNumber(totalArea) && angular.isNumber(this.ad.bargainTerms.price)) {
            this.ad.bargainTerms.price = Math.floor(this.ad.bargainTerms.price / totalArea);
          }
        }

        $scope.$watchGroup(
          [() => this.ad.category, () => angular.isObject(this.ad.land) && this.ad.land.areaUnitType],
          () => {
            setPriceType();
            const objectType = categoryService.getInfoByCategory(this.ad.category).objectType;
            this.showRange = ['freeAppointmentObject', 'office', 'shoppingArea'].includes(objectType);
          },
        );

        // todo: move these things to config by category
        this.getRateTitle = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);
          const name = objectType === 'garage' ? 'Цена' : 'Ставка';
          const unit = priceTypeText[this.ad.bargainTerms.priceType] || priceTypeText.squareMeter;

          return `${name} за ${unit}`;
        };

        this.getPriceTitle = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);

          return this.isRent || objectType === 'garage' ? 'Цена за объект' : 'Стоимость';
        };

        const validationMessages = {
          garage: {
            required: 'Не указана стоимость',
          },
          building: {
            required: 'Не указана стоимость',
          },
          default: {
            required: 'Укажите размер арендной ставки',
          },
        };
        this.getValidationMessages = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);

          return validationMessages[objectType] || validationMessages.default;
        };

        this.isVatVisible = () => {
          const { objectType } = categoryService.getInfoByCategory(this.ad.category);

          return (this.computedPrice.from || this.computedPrice.to) && vatVisibleForObjects.includes(objectType);
        };
      },
    ],
    controllerAs: 'priceRate',
    template,
  }),
]).name;
